import {
  Box,
  Button,
  FormControl,
  Grid,
  MenuItem,
  Select,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SyncIcon from "@mui/icons-material/Sync";
import FullCalendar from "@fullcalendar/react";
import allLocales from "@fullcalendar/core/locales-all";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimelinePlugin from "@fullcalendar/resource-timeline";
import multiMonthPlugin from "@fullcalendar/multimonth";
import dayGridPlugin from "@fullcalendar/daygrid";
import { fetchList } from "../../apis/services/CommonApiService";
import { ApiEndPoints } from "../../apis/ApiEndPoints";
import Loader from "../../layout/Loader";

const ExelJS = require("exceljs");


const MarketAnalysis = () => {
  const calendarRef = useRef(null);
  const [arg, setArg] = useState();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadingRate, setLoadingRate] = useState(false);
  const [eventss, setreservationEventss] = useState([]);
  const [resources, setResourcess] = useState([
    {
      competitor_hotel_name: "None",
    },
  ]);

  const [calenderView, setCalenderView] = useState({
    initialDate: moment().format("YYYY-MM-DD"),
    perMonth: 7,
  });

  const handlePrev = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      calendarApi.prev();
    }
  };

  const handleNext = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      calendarApi.next();
    }
  };

  const handleToday = () => {
    const calendarApi = calendarRef.current?.getApi();
    if (calendarApi) {
      calendarApi.today();
    }
  };

  const columns = [
    {
      field: "competitor_hotel_name",
      //   group: false,
      headerContent: t("Hotel Name"),
      //   cellContent: (args) =>
      //      t(args?.resource?.extendedProps?.competitor_hotel_name),
    },
  ];


  const handleGetResources = async () => {
    setLoading(true);
    const result = await fetchList(
      ApiEndPoints.GET_SUGGESTED_HOTEL_LIST +
        `?page_no=${1}&items_per_page=${1000}`
    );
    if (result?.status === 200) {
      setResourcess(result?.data?.rows);
      setLoading(false);
    } else {
      setResourcess([
        {
          competitor_hotel_name: "None",
        },
      ]);
      setLoading(false);
    }
  };

  const handleGetRateData = async (arg) => {
    setLoadingRate(true);
    const result = await fetchList(
      ApiEndPoints.GET_MARKET_ANALYSIS_RATE +
        `?start_date=${moment(arg?.startStr).format(
          "YYYY-MM-DD"
        )}&end_date=${moment(arg?.endStr).format("YYYY-MM-DD")}`
    );
    if (result?.status === 200) {
      let data = result?.data?.map((item) => ({
        start: moment(item?.date).format("YYYY-MM-DD"),
        resourceId: item?.competitor_hotel_id,
        title: item?.rate,
        textColor: "black",
        color: "transparent",
      }));
      let allDates = [];
      const startDate = moment(arg?.startStr);
      const endDate = moment(arg?.endStr);
      for (
        let m = moment(startDate);
        m.isSameOrBefore(endDate);
        m.add(1, "day")
      ) {
        const formattedDate = m.format("YYYY-MM-DD");
        allDates.push(formattedDate);
      }

      allDates.forEach((date) => {
        resources.forEach((resId) => {
          let findData = data?.find(
            (it) => it?.resourceId === resId?.id && it?.start === date
          );
          if (!findData) {
            data.push({
              start: date,
              resourceId: resId?.id,
              title: "-",
              textColor: "black",
              color: "transparent",
            });
          }
        });
      });
      setreservationEventss(data);
      setLoadingRate(false);
    } else {
      setreservationEventss([]);
      setLoadingRate(false);
    }
  };

  useEffect(() => {
    handleGetResources();
  }, []);

  useEffect(() => {
    if(arg?.startStr !== arg?.endStr && arg && resources?.length>0)
    handleGetRateData(arg);
  }, [arg,resources]);

   const exportToExcel = (dataHead, data, title) => {
      // console.log(dataHead,data, 634 )
      const workbook = new ExelJS.Workbook();
      const sheet = workbook.addWorksheet("Market rate");
      sheet.columns = dataHead?.map((item, ind) => ({
        key: item,
        width: ind === 0? 100 : 20,
      }));
  
      data?.forEach((columnData, index) => {
        const row = sheet?.addRow(columnData);
      });
  
      workbook.csv.writeBuffer().then((data) => {
        const blob = new Blob([data], {
          type: "text/csv;charset=utf-8",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        // document.body.appendChild(a);
        a.href = url;
        a.download =
          (title || "") +
          "_" +
          moment(arg?.startDate).format("MM-DD-YYYY") +
          "_to_" +
          moment(arg?.endDate).format("MM-DD-YYYY") +
          "_of_" +
          moment().format("MM-DD-YYYY");
        a.click();
        window.URL.revokeObjectURL(url);
        // document.body.removeChild(a);
      });
    };

    const exportRates = async () => {
      let dateHeader = ["cate"];
      let dateArray = [];
      const startDate = moment(arg?.startStr);
      const endDate = moment(arg?.endStr);
  
      setLoading(true);
      const result = await fetchList(
        ApiEndPoints.GET_MARKET_ANALYSIS_RATE +
          `?start_date=${moment(arg?.startStr).format(
            "YYYY-MM-DD"
          )}&end_date=${moment(arg?.endStr).format("YYYY-MM-DD")}`
      );
      let objHead = {};
      let allDates = [];
      // Generate all dates in sequence
      for (
        let m = moment(startDate);
        m.isSameOrBefore(endDate);
        m.add(1, "day")
      ) {
        const formattedDate = m.format("YYYY-MM-DD");
        allDates.push(formattedDate);
        if (!dateHeader.includes(formattedDate)) {
          dateHeader.push(formattedDate);
          objHead[formattedDate] = m.format("DD-MMM-YY");
        }
      }
      objHead["cate"] = "";
      dateArray.push(objHead);
  
      if (result?.status === 200) {
        setLoading(false);
  
        resources?.forEach((items) => {
          let obj = { cate: items?.competitor_hotel_name };
          allDates.forEach((date) => {
            const rateData = result?.data?.find(
              (item) => item?.competitor_hotel_id === items?.id && item?.date === date
            );
            obj[date] = rateData ? `$${rateData?.rate}` : "-"; // Default to "$0" if missing
          });

          dateArray?.push(obj);
        });
      } else {
        setLoading(false);
      }
      exportToExcel(dateHeader, dateArray, "Market_Rates");
    };


  return (
    <div>
      {(loading || loadingRate) && <Loader />}
      <div style={{ background: "#fff", width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "end",
            flexWrap: "wrap",
            gap: "10px",
          }}
        >
          <Button
            size="large"
            variant="contained"
            disableElevation
            className="comman-button"
            color="primary"
            onClick={handleToday}
          >
            Today
          </Button>
          <div>
            <Button
              size="large"
              variant="contained"
              disableElevation
              className="comman-button"
              sx={{
                borderTopRightRadius: "0px !important",
                borderBottomRightRadius: "0px !important",
                paddingRight: "5px !important",
              }}
              color="primary"
              onClick={handlePrev}
            >
              <ArrowBackIosIcon />
            </Button>
            <Button
              size="large"
              variant="contained"
              disableElevation
              className="comman-button"
              sx={{
                borderTopLeftRadius: "0px !important",
                borderBottomLeftRadius: "0px !important",
                paddingLeft: "5px !important",
              }}
              color="primary"
              onClick={handleNext}
            >
              <ArrowForwardIosIcon />
            </Button>
          </div>
          <Button
            variant="outlined"
            // className="m-1"
            sx={{
              border: "1px solid #BFBFBF",
              marginRight: "10px",
              padding: "7px",
              borderRadius: "12px",
            }}
              onClick={() => handleGetRateData(arg)}
          >
            <SyncIcon sx={{ fontSize: "18px" }} />
          </Button>
          <Grid container spacing={2} sx={{ width: "fit-content" }}>
            <Grid item lg={12} md={12} style={{ marginRight: "10px" }}>
              <FormControl size="small">
                <DatePicker
                  format="MM/DD/YYYY"
                  value={
                    calenderView?.initialDate
                      ? moment(calenderView?.initialDate, "YYYY-MM-DD")
                      : null
                  }
                  onChange={(newValue) =>
                    setCalenderView({
                      ...calenderView,
                      initialDate: newValue
                        ? moment(newValue).format("YYYY-MM-DD")
                        : "",
                    })
                  }
                  inputProps={{
                    style: {
                      padding: "3px",
                      borderRadius: "12px",
                    },
                  }}
                  sx={{
                    width: "fit-content",
                    maxWidth: "150px",
                    input: {
                      padding: "3px!important",
                      borderRadius: "12px !important",
                    },
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "12px !important",
                    },
                    borderRadius: "12px",
                  }}
                  slotProps={{
                    textField: {
                      readOnly: true,
                    },
                  }}
                />
              </FormControl>
            </Grid>
          </Grid>
          <FormControl sx={{ m: 0, marginRight: "10px" }} size="small">
            <Select
              value={calenderView?.perMonth}
              onChange={(e) =>
                setCalenderView({
                  ...calenderView,
                  perMonth: e.target.value,
                })
              }
              sx={{ height: "34px", borderRadius: "12px" }}
              displayEmpty
              inputProps={{ "aria-label": "Without label" }}
            >
              <MenuItem value={7}>{t("For One Week")}</MenuItem>
              <MenuItem value={14}>{t("For Two weeks")}</MenuItem>
              <MenuItem value={31}>{t("For One Month")}</MenuItem>
              <MenuItem value={60}>{t("For Two Month")}</MenuItem>
              <MenuItem value={88}>{t("For Three Months")}</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <div className="mt-2">
          <FullCalendar
            ref={calendarRef}
            initialDate={calenderView?.initialDate}
            key={calenderView?.initialDate}
            schedulerLicenseKey={"CC-Attribution-NonCommercial-NoDerivatives"} // Will need to purchase a license
            plugins={[
              interactionPlugin,
              resourceTimelinePlugin,
              multiMonthPlugin,
              dayGridPlugin,
            ]}
            locale={localStorage.getItem("lng") || "en"}
            locales={allLocales}
            // today prev,next
            headerToolbar={{
              right: "customButton1", // Add 'customButton' to the left side
              left: "title",
            }}
            customButtons={{
              customButton1: {
                text: t("Export Rates"),
                click: () => exportRates(),
              },
            }}
            // eventClick={handleEventClick}
            // timeZone="UTC"
            events={eventss}
            // eventContent={renderEventContent}
            resources={resources}
            // resourceGroupField="groupId"
            resourceAreaColumns={columns}
            initialView="resourceTimelineWeek"
            views={{
              resourceTimelineWeek: {
                duration: { days: calenderView?.perMonth },
                slotDuration: "24:00:00",
                slotLabelFormat: [
                  { weekday: "short", day: "2-digit", month: "short" },
                ],
                titleFormat: { day: "2-digit", month: "short" },
              },
            }}
            slotLabelContent={(slotInfo) => {
              const dayOfWeek = slotInfo.date.toLocaleString(
                localStorage.getItem("lng") || "en",
                {
                  weekday: "short",
                }
              );
              const dayOfMonth = slotInfo.date.toLocaleString(
                localStorage.getItem("lng") || "en",
                {
                  day: "numeric",
                }
              );
              const month = slotInfo.date.toLocaleString(
                localStorage.getItem("lng") || "en",
                {
                  month: "short",
                }
              );

              return (
                <div style={{ lineHeight: "18px", paddingInline: "15px" }}>
                  <div>{dayOfWeek}</div>
                  <div>{dayOfMonth}</div>
                  <div>{month}</div>
                </div>
              );
            }}
            datesSet={(argO) => {
              if (
                !(
                  argO?.startStr === arg?.startStr &&
                  argO?.endStr === arg?.endStr
                )
              ) {
                setArg(argO);
                setCalenderView({
                  ...calenderView,
                  initialDate: moment(argO?.startStr).format("YYYY-MM-DD"),
                });
              }
            }}
            sx={{
              "& .fc-timeline-event": {
                padding: "0px",
              },
            }}
            dragScroll
            resourceAreaWidth="42%"
            height={"auto"}
          />
        </div>
        {/* Market Analysis */}
      </div>
    </div>
  );
};

export default MarketAnalysis;
